import { QuestionStateMachineData, QuestionScore, resetQuestionAnswerAndEvaluation } from '../data'

export class EvaluatedState {
  public readonly name = 'evaluated'

  constructor(private data: QuestionStateMachineData,
              private questionScore: QuestionScore) {
  }

  stateEvents: {
    onShowSolution: () => void
    onReset: () => void
  }

  reset() {
    resetQuestionAnswerAndEvaluation(this.data, this.questionScore)
    this.stateEvents.onReset()
  }

  showSolution() {
    this.stateEvents.onShowSolution()
  }
}
